import { useParams } from "react-router-dom";
import { ESRFieldProps } from "../../types/data";
import {
  Button,
  TextField,
  IconButton,
  Chip,
  Box,
  Typography,
  Stack,
  Tooltip,
  Paper,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useRemoteField } from "../../hooks/useRemoteField";
import { useEffect, useState } from "react";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export const ESRMultiLineTextBox = (props: ESRFieldProps) => {
  const { question_id, required, locked, inline, hint_value } = props;
  const [value, setValue] = useRemoteField(question_id);
  const [textLists, setTextList] = useState<string[]>([])

  
	useEffect(() => {
			if (!value || value.trim() === "") {
				setTextList([]);
				return;
			}

			try {
				const parsed = JSON.parse(value);

				const ans = Array.isArray(parsed)
				? parsed
				: [parsed];

				setTextList(ans);
			} catch {
				// fallback: treat as plain string (or split if needed)
				const cleaned = value.trim();

				let ans;
				if (cleaned.includes(",")) {
				ans = cleaned.split(",").map(v => v.trim()).filter(Boolean);
				} else if (cleaned.includes(" ")) {
				ans = cleaned.split(/\s+/).filter(Boolean);
				} else {
				ans = [cleaned];
				}

				setTextList(ans);
			}
		}, [value]);

	const [user, setUser] = useCurrentUser();

  const [text, setText] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [editText, setEditText] = useState("");

  const [optionsStr] = useRemoteField(`${question_id}.OPTIONS`);
  let options: string[] = [];

  if(optionsStr){
    try {
      options = JSON.parse(optionsStr);
    } catch {}
  }
  let hints: string[] = []
  if(hint_value){
    try{
      if(!hint_value.includes('eg.')){
        hints = JSON.parse(hint_value)
      }
    }
    catch{}
  }

  const handleAddText = () => {
	
	if (!text || text.trim() === "") return;

	const timestamp = new Date().toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
    });
	const entry = question_id === 'A2' ? `[${timestamp}] ${user?.email}: ${text}`: `${text}` ;

	let safeList: string[] = [];
	
	if (Array.isArray(textLists)) {
		safeList = textLists;
	} else {
		try {
		const parsed = JSON.parse(textLists as any);
		safeList = Array.isArray(parsed) ? parsed : [];
		} catch {
		safeList = [];
		}
	}
	if (!safeList.includes(entry) && !options.includes(entry)) {
		const newList = [...safeList, entry];

		setTextList(newList);
		setValue(JSON.stringify(newList), locked === -1);
	}
    setText("");
  };

  const handleDeleteText = (textToDelete: string) => {
    const newList = textLists.filter((v) => v !== textToDelete);
    setTextList(newList);
    setValue(JSON.stringify(newList), locked === -1);
  };

  const handleSaveEdit = (index: any) => {
    let updatedList = [...textLists];
    updatedList[index] = editText;
    setValue(JSON.stringify(updatedList));
    setEditIndex(null);
    setEditText("");
  };

  const handleCopyText = (textToCopy: any) => {
    navigator.clipboard.writeText(textToCopy);
  };

  return (
		<>
			<Stack
				direction="column"
				spacing={1}
				sx={{
					display: "block",
					alignItems: "stretch",
					gap: 1,
				}}
			>
				{hints.length > 0 &&
					value === "" &&
					!hint_value.includes("eg.") &&
					hints.map((value, index) => {
						return (
							<Box
								sx={{ alignItems: "center", gap: 1, display: "flex" }}
								key={index}
							>
								<Paper
								elevation={1}
								sx={{
									width: "100%",
									p: 2,
									mb: 1,
									borderRadius: 2,
								}}
							>
								<Box
									sx={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "flex-start",
									}}
								>
									<Typography
										sx={{
											whiteSpace: "pre-wrap",
											wordBreak: "break-word",
											flexGrow: 1,
										}}
									>
										{value}
									</Typography>

									{/* <Tooltip title="Copy">
										<ContentCopyIcon
											fontSize="small"
											onClick={() => handleCopyText(value)}
											sx={{ cursor: "pointer", ml: 1 }}
										/>
									</Tooltip> */}
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											gap: 0.5,
											ml: 1,
										}}
									>
										<Tooltip title="Copy">
											<IconButton
												size="small"
												onClick={() => handleCopyText(value)}
											>
												<ContentCopyIcon fontSize="small" />
											</IconButton>
										</Tooltip>

										<Tooltip title="Delete">
											<IconButton
												size="small"
												disabled={locked > 0}
												onClick={() => handleDeleteText(value)}
											>
												<DeleteIcon
													fontSize="small"
													color={locked > 0 ? "disabled" : "error"}
												/>
											</IconButton>
										</Tooltip>
									</Box>
								</Box>
							</Paper>
							</Box>
						);
					})}
			</Stack>
			<Box>
				<Box>
					{textLists.length > 0 &&
						textLists.map((value, index) => (
							<Box
								key={`${index}-${value}`}
								sx={{
									width: "100%",
									display: "flex",
									alignItems: "center",
									marginBottom: 1,
								}}
							>
								<Paper
								elevation={1}
								sx={{
									width: "100%",
									p: 2,
									mb: 1,
									borderRadius: 2,
								}}
							>
								<Box
									sx={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "flex-start",
									}}
								>
									<Typography
										sx={{
											whiteSpace: "pre-wrap",
											wordBreak: "break-word",
											flexGrow: 1,
										}}
									>
										{value}
									</Typography>

									{/* <Tooltip title="Copy">
										<ContentCopyIcon
											fontSize="small"
											onClick={() => handleCopyText(value)}
											sx={{ cursor: "pointer", ml: 1 }}
										/>
									</Tooltip> */}
									<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: 0.5,
										ml: 1,
									}}
								>
									<Tooltip title="Copy">
										<IconButton
											size="small"
											onClick={() => handleCopyText(value)}
										>
											<ContentCopyIcon fontSize="small" />
										</IconButton>
									</Tooltip>

									<Tooltip title="Delete">
										<IconButton
											size="small"
											disabled={locked > 0}
											onClick={() => handleDeleteText(value)}
										>
											<DeleteIcon
												fontSize="small"
												color={locked > 0 ? "disabled" : "error"}
											/>
										</IconButton>
									</Tooltip>
								</Box>
								</Box>
							</Paper>
							</Box>
						))}
				</Box>
			</Box>
			<Box
				sx={{ display: "flex", alignItems: "center", gap: 1, marginTop: "2%" }}
			>
				<TextField
					fullWidth
					multiline
					minRows={4}
					maxRows={10}
					value={text}
					disabled={locked > 0}
					onChange={(e) => {
						setText(e.target.value);
					}}
				/>
				<IconButton
					disabled={locked > 0}
					color="primary"
					onClick={handleAddText}
					size="small"
					sx={{ p: 0 }}
				>
					<AddCircleIcon />
				</IconButton>
			</Box>
		</>
	);
};